import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useParams } from "react-router-dom";

import { Modal, Input, Space, Button, Table } from "antd";
import {
  FilePdfOutlined,
  SearchOutlined,
  DownloadOutlined,
} from "@ant-design/icons";

import moment from "moment";

import { Document, Page } from "react-pdf";

import Highlighter from "react-highlight-words";

import { getRobotReports } from "../reports/reportSlice";
import LoadingPage from "../../components/LoadingPage";

import { fileSize } from "../../libs/utils";

import { pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const ReportsList = (prop) => {
  const dispatch = useDispatch();
  const { robotName } = useParams();
  const robotId = robotName.match(/(\d+)/)[0];

  const reports = useSelector((state) => state.reports.reports);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  useEffect(() => {
    dispatch(getRobotReports(robotId));
  }, [dispatch, robotId]);

  if (!reports) {
    return <LoadingPage />;
  }

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Clear
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput, 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setSelectedItem(null);
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: "60%",
      sorter: {
        compare: (a, b) => {
          const aString = a.name.toLowerCase();
          const bString = b.name.toLowerCase();

          if (aString > bString) {
            return 1;
          }
          if (aString < bString) {
            return -1;
          }
          return 0;
        },
      },
      ...getColumnSearchProps("name"),
    },
    {
      title: "Size",
      key: "size",
      width: "20%",
      render: (_, item) => <span>{fileSize(item.size)}</span>,
    },
    {
      title: "Uploaded At",
      key: "date",
      width: "20%",
      sorter: {
        compare: (a, b) => {
          const aString = a.date;
          const bString = b.date;

          if (aString > bString) {
            return 1;
          }
          if (aString < bString) {
            return -1;
          }
          return 0;
        },
      },
      render: (_, item) => (
        <span>{moment(item.date).format("YYYY-MM-DD, HH:mm:ss")}</span>
      ),
    },
    {
      title: "View",
      dataIndex: "",
      key: "download",
      render: (item) => (
        <FilePdfOutlined
          onClick={() => {
            setSelectedItem(item);
            setModalOpen(true);
          }}
        />
      ),
    },
    {
      title: "Download",
      dataIndex: "",
      key: "download",
      render: (item) => (
        <a
          href={item.download}
          download
          target="_blank"
          rel="noopener noreferrer"
        >
          <DownloadOutlined />
        </a>
      ),
    },
  ];
  const data = reports.map((item, index) => {
    return {
      key: index,
      name: item.fileName,
      size: item.size,
      date: item.uploadedAt,
      download: item.url,
    };
  });

  return (
    <>
      <Table columns={columns} dataSource={data}></Table>
      {modalOpen && !!selectedItem && (
        <Modal
          title={selectedItem.name}
          visible={modalOpen}
          centered
          bodyStyle={{ height: "80%" }}
          width={"70%"}
          onOk={handleModalClose}
          onCancel={handleModalClose}
        >
          <PDFViewer item={selectedItem} />
        </Modal>
      )}
    </>
  );
};

export const PDFViewer = ({ item }) => (
  <Document
    file={item.download}
    onLoadSuccess={() => console.log("PDF successfully loaded")}
  >
    <Page pageNumber={1}></Page>
  </Document>
);

export default ReportsList;
